import LegalShell from "@/pages/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms & Conditions" effective="1 February 2026">
      <p>
        Welcome to <strong>RIF Master</strong> (the <em>Service</em>), a clinical decision-support tool for the
        management of Recurrent Implantation Failure (RIF), owned and operated by
        <strong> Dr. Mona Shroff, MD</strong> (the <em>Owner</em>). By creating an account, subscribing to lifetime
        access, or otherwise using the Service you agree to these Terms &amp; Conditions.
      </p>

      <h2>1. Eligibility & intended users</h2>
      <p>
        The Service is intended <strong>solely for use by qualified reproductive medicine and IVF specialists</strong>.
        By registering you represent that you are a medical practitioner registered with the National Medical Commission
        of India (or an equivalent regulator) and that you will use the Service only in the course of professional
        clinical practice. The Service is not intended for use by patients or by the general public.
      </p>

      <h2>2. Not medical advice</h2>
      <p>
        The dosing protocols, references and outputs produced by the Service are decision-support material and do
        <strong> not constitute a diagnosis, treatment plan, or prescription</strong>. The treating clinician retains
        sole responsibility for every clinical decision, including drug choice, dose, route, timing and
        individualisation to the patient in front of them. The Owner accepts no liability for outcomes arising from
        the use of Service outputs.
      </p>

      <h2>3. Account, subscription & lifetime access</h2>
      <ul>
        <li>Registration is per individual clinician. Sharing credentials with another person is prohibited.</li>
        <li>Access is granted on receipt of a one-time payment of <strong>₹4,999 (INR)</strong>, unlocking the
          Service for the natural lifetime of the Service. The Owner may retire or migrate the Service on 90 days'
          written notice.</li>
        <li>Payments are processed by Razorpay Software Pvt. Ltd. and are subject to Razorpay's terms in addition
          to these Terms.</li>
      </ul>

      <h2>4. Acceptable use</h2>
      <ul>
        <li>Do not attempt to reverse engineer, resell, scrape, or automate access to the Service.</li>
        <li>Do not upload personally identifying patient information — use only initials, case codes or de-identified
          labels in patient records within the Service.</li>
        <li>Do not use the Service for unlawful purposes or in violation of applicable clinical governance rules.</li>
      </ul>

      <h2>5. Intellectual property</h2>
      <p>
        All content, algorithms, protocols, database schemas, branding and generated PDF outputs are the intellectual
        property of the Owner. You are granted a limited, non-transferable licence to use the Service and to include
        generated protocol PDFs in individual patient files. You may not redistribute Service content on public
        websites, textbooks, courses or aggregators without prior written permission.
      </p>

      <h2>6. Third-party services</h2>
      <p>
        The Service uses Razorpay for payment processing, Resend for transactional email, MongoDB Atlas for data
        storage and various open-source libraries. Their respective terms and privacy policies apply to their portion
        of the flow.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, the Owner's aggregate liability arising out of or relating to the
        Service is limited to the amount you actually paid for lifetime access in the twelve months preceding the
        claim. The Owner is not liable for any indirect, incidental, punitive, or consequential damages, including
        loss of profits, data or reputation.
      </p>

      <h2>8. Termination</h2>
      <p>
        The Owner may suspend or terminate access for material breach of these Terms without refund. On termination
        the clinician may request an export of their saved case data within 30 days, after which the data may be
        permanently deleted.
      </p>

      <h2>9. Governing law & jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. All disputes are subject to the exclusive jurisdiction of the
        courts at <strong>Mumbai, Maharashtra</strong>.
      </p>

      <h2>10. Changes</h2>
      <p>
        These Terms may be updated from time to time. Material changes will be highlighted on the login page for at
        least 30 days. Continued use of the Service constitutes acceptance of the revised Terms.
      </p>

      <h2>11. Contact</h2>
      <p>
        For any questions about these Terms, email <a href="mailto:drmonashroff@gmail.com">drmonashroff@gmail.com</a>.
      </p>
    </LegalShell>
  );
}
